import queryString$1 from 'query-string';
import { isLocalStorageSupported, isSessionStorageSupported } from '@zillow/is-local-storage-supported';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded = ["dedup"];
/**
 * Parse url search string into an object.
 * Object property keys are the parameter names, and corresponding property values are the parameter values.
 * By default, if there are multiple parameters with the same name pick the last one.
 */

function enhancedParse(search) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref$dedup = _ref.dedup,
      dedup = _ref$dedup === void 0 ? true : _ref$dedup,
      restOptions = _objectWithoutProperties(_ref, _excluded);

  try {
    var result = queryString$1.parse(search, restOptions);
    Object.keys(result).forEach(function (key) {
      var resultValue = result[key];

      if (dedup && resultValue instanceof Array) {
        // Only take the last value
        result[key] = resultValue[resultValue.length - 1];
      } // 'novalue&' will be parsed as { novalue: null }
      // we want to clean up all keys with null values
      // so that later they will not be included for stringify


      if (result[key] === null || result[key] === undefined) {
        // eslint-disable-next-line zillow/@typescript-eslint/no-dynamic-delete
        delete result[key];
      }
    }); // the object returned from queryString.parse has null prototype (Object.getPrototypeOf)
    // convert it to an object literal
    // so it can be compared with other object literal using strict equality

    return _objectSpread2({}, result);
  } catch (err) {
    console.warn(err);
    return {};
  }
}
/**
 * Merge multiple query strings into one, if there are multiple parameters with the same name, pick the last one.
 * E.g. merge('a=a&b=b', 'c=c', 'c=c2&d=d') => 'a=a&b=b&c=c2&d=d'
 */


function merge() {
  for (var _len = arguments.length, searches = new Array(_len), _key = 0; _key < _len; _key++) {
    searches[_key] = arguments[_key];
  }

  var search = searches.filter(function (s) {
    return !!s;
  }).join('&');
  var queryParams = enhancedParse(search);
  return queryString$1.stringify(queryParams);
}

var queryString = _objectSpread2(_objectSpread2({}, queryString$1), {}, {
  merge: merge,
  parse: enhancedParse
});

var createInternalStorage = function createInternalStorage() {
  var mapInstance = new Map();
  return {
    getItem: function getItem(key) {
      return mapInstance.get(key);
    },
    removeItem: function removeItem(key) {
      mapInstance.delete(key);
    },
    setItem: function setItem(key, value) {
      return mapInstance.set(key, value !== null && value !== void 0 ? value : null);
    }
  };
};

/**
 * Detect whether current javascript runtime is a browser-like environment
 * (including mobile browser and RE app webview).
 */
function isBrowser() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
}

var getLocalStorageAPI = function getLocalStorageAPI() {
  var KEY_PREFIX = 'static-zo-growth-';
  var localStorage;

  if (isLocalStorageSupported()) {
    var _window = window;
    localStorage = _window.localStorage;
  } else {
    localStorage = createInternalStorage();
  }

  return {
    getItem: function getItem(key) {
      try {
        return localStorage.getItem("".concat(KEY_PREFIX).concat(key));
      } catch (_unused) {
        return null;
      }
    },
    removeItem: function removeItem(key) {
      try {
        localStorage.removeItem("".concat(KEY_PREFIX).concat(key));
        return undefined;
      } catch (_unused2) {
        return undefined;
      }
    },
    setItem: function setItem(key, value) {
      try {
        localStorage.setItem("".concat(KEY_PREFIX).concat(key), value);
        return undefined;
      } catch (_unused3) {
        return undefined;
      }
    }
  };
};

var localStorageAPI = getLocalStorageAPI();
function saveToLocalStorage(key, value) {
  // If running on nodejs, do not save to localStorage.
  // This is specifically for Server side render, as we do not
  // want to store any state between each render while SSR.
  if (!isBrowser()) {
    return;
  }

  if (value) {
    localStorageAPI.setItem(key, value);
  } else {
    localStorageAPI.removeItem(key);
  }
}
function getFromLocalStorage(key) {
  return localStorageAPI.getItem(key);
}

var fallbackWindow = {
  location: {
    search: ''
  },
  navigator: {
    userAgent: ''
  }
};
/**
 * Returns global window object if it is available.
 * Otherwise, return a fallback window object.
 */

var getGlobalWindow = function getGlobalWindow() {
  if (!isBrowser()) {
    return fallbackWindow;
  }

  return window;
};

var getEntrySourceFromUrl = function getEntrySourceFromUrl() {
  var globalWindow = getGlobalWindow(); // e.g. ?t=ios-more-menu

  var tValue = queryString.parse(globalWindow === null || globalWindow === void 0 ? void 0 : globalWindow.location.search).t;

  if (tValue) {
    return tValue;
  }

  return null;
};

var SimpleBus = function SimpleBus() {
  var _this = this;

  _classCallCheck(this, SimpleBus);

  _defineProperty(this, "listenerList", void 0);

  _defineProperty(this, "callListeners", function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this.listenerList.forEach(function (subFunc) {
      subFunc.apply(void 0, args);
    });
  });

  _defineProperty(this, "addListener", function (func) {
    _this.listenerList.push(func);

    var wrapper = {
      cancel: function cancel() {
        _this._removeListener(func);
      },
      func: func
    };
    return wrapper;
  });

  _defineProperty(this, "_removeListener", function (func) {
    var index = _this.listenerList.indexOf(func);

    _this.listenerList = [].concat(_toConsumableArray(_this.listenerList.slice(0, index)), _toConsumableArray(_this.listenerList.slice(index + 1)));
  });

  this.listenerList = [];
};

var getSessionStorageAPI = function getSessionStorageAPI() {
  var KEY_PREFIX = 'static-zo-growth-';
  var globalWindow = getGlobalWindow();
  var sessionStorage; // in strict mode, error will be thrown if window is never defined and is used directly in boolean expression

  if (isSessionStorageSupported() && globalWindow) {
    sessionStorage = globalWindow.sessionStorage;
  } else {
    sessionStorage = createInternalStorage();
  }

  return {
    getItem: function getItem(key) {
      return sessionStorage.getItem("".concat(KEY_PREFIX).concat(key));
    },
    removeItem: function removeItem(key) {
      return sessionStorage.removeItem("".concat(KEY_PREFIX).concat(key));
    },
    setItem: function setItem(key, value) {
      return sessionStorage.setItem("".concat(KEY_PREFIX).concat(key), value);
    }
  };
};

var SessionStorageAPI = getSessionStorageAPI();
var simpleFunctionBus = new SimpleBus();

var setItem = function setItem(key, value) {
  SessionStorageAPI.setItem(key, value);
  simpleFunctionBus.callListeners(key, value);
};

var removeItem = function removeItem(key) {
  SessionStorageAPI.removeItem(key);
  simpleFunctionBus.callListeners(key);
};

var getItem = function getItem(key) {
  return SessionStorageAPI.getItem(key);
};

var addSessionStorageUpdateHandler = function addSessionStorageUpdateHandler(callback) {
  return simpleFunctionBus.addListener(callback);
};
/* 
    isQuestionnaireAutoStarted tells if the questionnaire flow was triggered by auto submit
    on ZO landing, and is used to determine if we should show ZO onboarding or ZO rewards UI.

    TODO: integrate session-storage in redux persistent layer
    TODO: clean up both getIsQuestionnaireAutoStarted & setIsQuestionnaireAutoStarted
 */

var IS_QUESTIONNAIRE_AUTO_SUBMITTED = 'isQuestionnaireAutoStarted';
var getIsQuestionnaireAutoStarted = function getIsQuestionnaireAutoStarted() {
  return Boolean(getItem(IS_QUESTIONNAIRE_AUTO_SUBMITTED));
};
var setIsQuestionnaireAutoStarted = function setIsQuestionnaireAutoStarted(value) {
  return setItem(IS_QUESTIONNAIRE_AUTO_SUBMITTED, value || '');
};
/*
    Sessionized entrySource is used for checking which upsell user is coming from.
    It remains the same when user refreshes the page.

    Contrast to the entrySource stored in *localStorage* as part of questionnaire answers,
    we do not persist this value permanently because it is meant to be scoped with current tab only.
*/

var SESSION_ENTRY_SOURCE = 'sessionEntrySource';
var getSessionEntrySource = function getSessionEntrySource() {
  var _getItem;

  return (_getItem = getItem(SESSION_ENTRY_SOURCE)) !== null && _getItem !== void 0 ? _getItem : '';
};
var setSessionEntrySource = function setSessionEntrySource(value) {
  return setItem(SESSION_ENTRY_SOURCE, value !== null && value !== void 0 ? value : '');
};
/*
    This is used for storing the url of the page from which user comes to ZO landing for *the first time*.
    Initially, its value is set from "document.referer" and remains unchanged in the same tab.

    "document.referer" is unreliable in some cases.
    For example, if user reloads the page by re-entering the same url again in the same tab,
    "document.referer" will be set to empty.

    Another issue is Chrome specific following the steps below:
    1. User is navigated from FS HDP upsell to ZO Landing (by changing "window.location.href" on HDP).
    2. User enters questionnaire without page reload and fills out all questions.
    3. User submits questionnaire and the page reloads with photo uploader url.
    4. User navigates back from photo uploader.
    After above steps, the expected "document.referrer" is HDP url, but in fact it is questionnaire url.
*/

var LAST_EXTERNAL_QUESTIONNAIRE_REFERRER = 'lastExternalQuestionnaireReferrer';
var getLastExternalQuestionnaireReferrer = function getLastExternalQuestionnaireReferrer() {
  return getItem(LAST_EXTERNAL_QUESTIONNAIRE_REFERRER);
};
var setLastExternalQuestionnaireReferrer = function setLastExternalQuestionnaireReferrer(value) {
  return setItem(LAST_EXTERNAL_QUESTIONNAIRE_REFERRER, value !== null && value !== void 0 ? value : '');
};
/* 
    detailedAddressSearchResult is used for sharing address search match details
    between address search component (on both ZO landing and marketing landing) and
    Email waitlist page.
*/

var DETAILED_ADDRESS_SEARCH_RESULT = 'detailedAddressSearchResult';
var getDetailedAddressSearchResult = function getDetailedAddressSearchResult() {
  var detailedAddressSearchResult = getItem(DETAILED_ADDRESS_SEARCH_RESULT);

  if (detailedAddressSearchResult) {
    return JSON.parse(detailedAddressSearchResult);
  }

  return undefined;
};
var setDetailedAddressSearchResult = function setDetailedAddressSearchResult(value) {
  return setItem(DETAILED_ADDRESS_SEARCH_RESULT, JSON.stringify(value || ''));
};
var clearDetailedAddressSearchResult = function clearDetailedAddressSearchResult() {
  return removeItem(DETAILED_ADDRESS_SEARCH_RESULT);
};

var ZILLOW_OFFERS_BASE_NAME = '/offers';
function getUrlQueryParams() {
  var _getGlobalWindow;

  return queryString.parse((_getGlobalWindow = getGlobalWindow()) === null || _getGlobalWindow === void 0 ? void 0 : _getGlobalWindow.location.search);
}
function getIsMobileWeb() {
  var _getGlobalWindow2;

  return Boolean((_getGlobalWindow2 = getGlobalWindow()) === null || _getGlobalWindow2 === void 0 ? void 0 : _getGlobalWindow2.navigator.userAgent.includes('Mobi'));
}
/**
 * isAppWebView
 */

var IS_APP_WEB_VIEW_KEY = 'isMobileAppWebView';
function getIsAppWebView() {
  var globalWindow = getGlobalWindow();

  var _queryString$parse = queryString.parse(globalWindow === null || globalWindow === void 0 ? void 0 : globalWindow.location.search),
      fromapp = _queryString$parse.fromapp,
      fromApp = _queryString$parse.fromApp; // handy override for debugging purpose


  if (fromapp === 'false' || fromApp === 'false') {
    return false;
  }

  var isMobileAppWebViewLocalStorage = Boolean(getFromLocalStorage(IS_APP_WEB_VIEW_KEY));
  var isIOS = Boolean(fromapp) || Boolean(fromApp) || isMobileAppWebViewLocalStorage;
  var isAndroid = Boolean(globalWindow === null || globalWindow === void 0 ? void 0 : globalWindow.navigator.userAgent.includes('ZillowApp'));
  return isIOS || isAndroid;
}
function getIsMobile() {
  return getIsAppWebView() || getIsMobileWeb();
}
function saveIsAppWebViewToLocalStorage(value) {
  saveToLocalStorage(IS_APP_WEB_VIEW_KEY, value);
}
/**
 * entrySource
 */

var ENTRY_SOURCE_KEY = 'zoEntrySource';
function getEntrySource() {
  var entrySourceFromUrl = getEntrySourceFromUrl();

  if (entrySourceFromUrl) {
    return entrySourceFromUrl;
  } // fallback to stored item


  return getFromLocalStorage(ENTRY_SOURCE_KEY);
}
function saveEntrySource(value) {
  saveToLocalStorage(ENTRY_SOURCE_KEY, value);
}
/**
 * lastVisitedLandingPageUrl
 */

var LAST_VISITED_LANDING_PAGE_URL_KEY = 'lastVisitedLandingPageUrl';
function saveLastVisitedLandingPageUrl(value) {
  saveToLocalStorage(LAST_VISITED_LANDING_PAGE_URL_KEY, value);
}
function getLastVisitedLandingPagePath() {
  var _getFromLocalStorage;

  return (_getFromLocalStorage = getFromLocalStorage(LAST_VISITED_LANDING_PAGE_URL_KEY)) !== null && _getFromLocalStorage !== void 0 ? _getFromLocalStorage : '';
}
/**
 * lastVisitedLandingPageHrefPath
 */

function getLastVisitedLandingPageHrefPath() {
  return "".concat(ZILLOW_OFFERS_BASE_NAME).concat(getLastVisitedLandingPagePath());
}
function saveValueForKey(key, value) {
  return saveToLocalStorage(key, value ? JSON.stringify(value) : '');
}
function getByKey(key) {
  var value = getFromLocalStorage(key);

  if (value) {
    return JSON.parse(value);
  }

  return undefined;
}
/**
 * zoIneligibleDetails
 */

var ZO_INELIGIBLE_DETAILS_KEY = 'zoIneligibleDetails';
function saveZoIneligibleDetails(value) {
  saveValueForKey(ZO_INELIGIBLE_DETAILS_KEY, value);
}
function getZoIneligibleDetails() {
  return getByKey(ZO_INELIGIBLE_DETAILS_KEY);
}
/**
 * matchedPropertyEligibilityDetails
 */

var MATCHED_PROPERTY_ELIGIBILITY_DETAILS_KEY = 'matchedPropertyEligibilityDetails';
function saveMatchedPropertyEligibilityDetails(value) {
  saveValueForKey(MATCHED_PROPERTY_ELIGIBILITY_DETAILS_KEY, value);
}
function getMatchedPropertyEligibilityDetails() {
  return getByKey(MATCHED_PROPERTY_ELIGIBILITY_DETAILS_KEY);
}

export { addSessionStorageUpdateHandler, clearDetailedAddressSearchResult, getByKey, getDetailedAddressSearchResult, getEntrySource, getEntrySourceFromUrl, getFromLocalStorage, getGlobalWindow, getIsAppWebView, getIsMobile, getIsMobileWeb, getIsQuestionnaireAutoStarted, getLastExternalQuestionnaireReferrer, getLastVisitedLandingPageHrefPath, getLastVisitedLandingPagePath, getMatchedPropertyEligibilityDetails, getSessionEntrySource, getUrlQueryParams, getZoIneligibleDetails, isBrowser, queryString, saveEntrySource, saveIsAppWebViewToLocalStorage, saveLastVisitedLandingPageUrl, saveMatchedPropertyEligibilityDetails, saveToLocalStorage, saveValueForKey, saveZoIneligibleDetails, setDetailedAddressSearchResult, setIsQuestionnaireAutoStarted, setLastExternalQuestionnaireReferrer, setSessionEntrySource };
